import { Attachment, Description, DirectionsBoat } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { changes, fields } from "src/components/utils/fields";
import { QuoteFormField } from "./QuoteFormField";

export const ServiceTypeDefaultValues = ({ dataState, setDataState }) => {
  const { t } = useTranslation();

  const exchangeTypeOptions = [
    { label: t('Sale'), value: 'S' },
    { label: t('Average'), value: 'A' },
    { label: t('Buy'), value: 'B' },
  ]

  const multipleOptions = [
    { label: t('Equipment'), value: 'E' },
    { label: t('Document'), value: 'D' },
    { label: t('Process'), value: 'P' },
    { label: t('Weight'), value: 'W' },
    { label: t('Measures'), value: 'M' },
    { label: t('Percentage'), value: 'C' },
    { label: t('Other'), value: 'O' },
    { label: t('TEU'), value: 'T' },
    { label: t('Quantity'), value: 'Q' },
    { label: t('KG 6 DM3'), value: 'G' },
    { label: t('K6'), value: 'K' },
  ]

  const payableHowOptions = [
    { label: t('Prepaid'), value: 'P' },
    { label: t('Collect'), value: 'C' },
    { label: t('Prep. Else'), value: 'Q' },
    { label: t('Coll. Else'), value: 'D' },
    { label: t('Other'), value: 'O' },
    { label: t('BLANK'), value: '' },
  ]

  const payingCompanyOptions = [
    { label: t('Client'), value: 'C' },
    { label: t('Other - Foreign Currency'), value: 'E' },
    { label: t('Invoice'), value: 'I' },
    { label: t('Shipper'), value: 'S' },
    { label: t('Consignee'), value: 'G' },
    { label: t('Notify'), value: 'N' },
    { label: t('Agent'), value: 'A' },
    { label: t('Feeder'), value: 'F' },
    { label: t('Other'), value: 'O' },
  ]

  const goalOptions = [
    { label: t('Line'), value: 'L' },
    { label: t('Agent Only'), value: 'A' },
    { label: t('Commission'), value: 'O' },
  ]

  const formFields = [
    {
      display: t('ExchangeType'),
      required: false,
      code: 'ExchangeType',
      type: 'select',
      options: exchangeTypeOptions,
      extraField: 'ExchangeTypeValue',
    },
    {
      size: 170,
      display: t('Multiple'),
      required: false,
      code: 'SalesMultiple',
      type: 'select',
      options: multipleOptions,
      extraField: 'SalesMultipleValue',
    },
    { display: t("SalesServiceValue"), required: false, code: "SalesValue", type: "number" },
    {
      display: t('PayableHow'),
      required: false,
      code: 'PayableHow',
      type: 'select',
      options: payableHowOptions,
      extraField: 'PayableHowValue',
    },
    {
      display: t('PayingCompany'),
      required: false,
      code: 'PayingCompany',
      type: 'select',
      options: payingCompanyOptions,
      extraField: 'PayingCompanyValue',
    },
    {
      display: t('Goal'),
      required: false,
      code: 'Goal',
      type: 'select',
      options: goalOptions,
      extraField: 'GoalValue',
    },
  ];

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <Attachment style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("DefaultValues")}
          </div>
        }
        elements={
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {formFields.map((field, index) => <QuoteFormField fields={field} index={index} options={field?.options} data={dataState} setData={setDataState} />)}
          </div>
        }
      />
    </>
  );
};
